import {getAdjustedPlantId} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'

import {useUrlParam} from '../../hooks'
import {Api} from '../api'

export const GetPlantUpmIdQueryKey = 'kmsPlants'

export const usePlantUpmId = () => {
  const {data} = useGetPlantUpmId()
  return data?.upmId
}

export const useGetPlantUpmId = () => {
  const plantId = useUrlParam('plantCode')

  return useQuery({
    queryKey: [GetPlantUpmIdQueryKey, getAdjustedPlantId(plantId)],
    queryFn: async () => {
      const path = `/kms/plants/${getAdjustedPlantId(plantId)}`
      return (await Api.axiosInstance.get<{upmId: string}>(path)).data
    },
    staleTime: Infinity
  })
}
